import { ActionType } from '../constants/ActionType';
import { SignOutAction } from './Auth';
import { Action } from 'redux';

export const setCurrentCommunityId = (communityId: number): SetCurrentCommunityIdAction => {
  return {
    type: ActionType.SET_CURRENT_COMMUNITY_ID,
    communityId,
  };
};

export interface SetCurrentCommunityIdAction extends Action<ActionType.SET_CURRENT_COMMUNITY_ID> {
  type: ActionType.SET_CURRENT_COMMUNITY_ID;
  communityId: number;
}

export const clearCurrentCommunityId = (): ClearCurrentCommunityIdAction => {
  return {
    type: ActionType.CLEAR_CURRENT_COMMUNITY_ID,
  };
};

export interface ClearCurrentCommunityIdAction extends Action<ActionType.CLEAR_CURRENT_COMMUNITY_ID> {
  type: ActionType.CLEAR_CURRENT_COMMUNITY_ID;
}

export const setCurrentAccountId = (accountId: number): SetCurrentAccountIdAction => {
  return {
    type: ActionType.SET_CURRENT_ACCOUNT_ID,
    accountId,
  };
};

export interface SetCurrentAccountIdAction extends Action<ActionType.SET_CURRENT_ACCOUNT_ID> {
  type: ActionType.SET_CURRENT_ACCOUNT_ID;
  accountId: number;
}

export const clearCurrentAccountId = (): ClearCurrentAccountIdAction => {
  return {
    type: ActionType.CLEAR_CURRENT_ACCOUNT_ID,
  };
};

export interface ClearCurrentAccountIdAction extends Action<ActionType.CLEAR_CURRENT_ACCOUNT_ID> {
  type: ActionType.CLEAR_CURRENT_ACCOUNT_ID;
}

export type UserAction =
  | SignOutAction
  | SetCurrentCommunityIdAction
  | ClearCurrentCommunityIdAction
  | SetCurrentAccountIdAction
  | ClearCurrentAccountIdAction;
